module.exports = __webpack_public_path__ + "b77b9cda19f45281eb27a2c2fc3127a5.jpg";